import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Descriptions, notification, Typography } from 'antd';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import AjaxTable from '../../../components/AjaxTable';
import { filtersearch } from '../../../api/module/contract_search';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import Paragraph from 'antd/lib/typography/Paragraph';
import { get } from '../../../api/module/contractor_search';
import MESSAGES from '../../../enums/Messages';
import SpinLoad from '../../../components/SpinLoad';
import CustomButton from '../../../components/CustomButton';
import { catchExceptionSRate } from '../../../utils/helpers/helpers';

const { Title } = Typography;

const ResumeContractSearchPersonDetail = ({ match, history }) => {
  const breadcrumbItems = [
    {
      text: 'Búsqueda de Documentos Contractuales',
      to: `${INTERNAL_LINKS.RESUME_CONTRACT_SEARCH}`,
    },
    {
      text: 'Contratos por persona',
    },
  ];

  const columns = [
    {
      title: 'Proyecto',
      dataIndex: 'proyecto_nombre',
      key: 'proyecto_nombre',
    },
    {
      title: 'No. Contrato',
      dataIndex: 'numero_contrato',
      key: 'numero_contrato',
    },
    {
      title: 'Cargo',
      dataIndex: 'cargo_nombre',
      key: 'cargo_nombre',
    },
    {
      title: 'Acciones',
      dataIndex: 'id',
      key: 'id',
      render: (_, record) =>
        record.estado_contratista === 54 ? (
          <Paragraph>Contrato no aceptado</Paragraph>
        ) : record.firma_proceso === 4 ? (
          <Button type="primary">
            <Link
              to={`${INTERNAL_LINKS.RESUME_CONTRACT_SEARCH}-detail/${record.id}/${record.proyecto_id}/${record.cargo_id}/${record.tercero}`}
            >
              Ver
            </Link>
          </Button>
        ) : (
          <>
            <Paragraph>El proceso de contratación esta en curso</Paragraph>
            <Paragraph strong>
              Recargue el listado mínimo pasados 5 minutos
            </Paragraph>
          </>
        ),
    },
  ];

  const [terceroData, setTerceroData] = useState();

  const getTerceroData = async () => {
    try {
      const res = await get(match.params.id);
      setTerceroData(res.data);
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_SEARCH_MSG);
    }
  };

  useEffect(() => {
    getTerceroData();
  }, []);

  const back = () => {
    history.push(`${INTERNAL_LINKS.RESUME_CONTRACT_SEARCH}/1`);
  };

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />

      <div className="box-title">
        <Title>DOCUMENTOS CONTRACTUALES</Title>
      </div>
      <p>
        A continuación se muestra la lista de los contratos en los que ha
        participado.
      </p>

      <SpinLoad loading={!terceroData}>
        <Descriptions bordered={true} column={2}>
          <Descriptions.Item label="Nombre completo / Razón social" span={2}>
            {terceroData && terceroData.nombre_completo_q}
          </Descriptions.Item>
          <Descriptions.Item label="Tipo de documento">
            {terceroData && terceroData.tipo_identificacion_sigla}
          </Descriptions.Item>
          <Descriptions.Item label="Número de documento">
            {terceroData && terceroData.numero_identificacion}
          </Descriptions.Item>
        </Descriptions>
      </SpinLoad>

      <AjaxTable
        endpointFetch={async (page, pageSize) => {
          const thisQuery = `filter[tercero]=${match.params.id}`;
          return await filtersearch(`?${thisQuery}`, page, pageSize);
        }}
        columns={columns}
        reloadButton
      />
      <CustomButton
        type={'default'}
        className={'back-button'}
        htmlType="button"
        onClick={() => back()}
        text="Volver"
      />
    </>
  );
};

export default ResumeContractSearchPersonDetail;
